import {ListItemViewModel} from "../../../../../infrastructure/models/list-item.view-model";

export class MatchEventsModuleTabViewModel extends ListItemViewModel {
  isMajor: boolean = false;

  constructor(model: MatchEventsModuleTabViewModel) {
    super(model);

    this.isMajor = model.isMajor;
    this.type = model.type
  }
}
